module.exports = __webpack_public_path__ + "img/6-1.1f6a1022.png";